$(document).on('ready', function(){
  cookiesPolicyBar();
  $(document).on("change", 'input#donation', function () {
    if (this.checked) {
      var qty = '1';
      $.ajax({
        url: '/cart/update.js?updates[39257946619966]='+qty,
        type: 'post',
        dataType: 'json',
        contentType: 'application/json',
        success: function (data) {
          setTimeout(function(){location.reload();},1000);
        }
      });
    }else{
      $.ajax({
        url: '/cart/update.js?updates[39257946619966]=0',
        type: 'post',
        dataType: 'json',
        contentType: 'application/json',
        success: function (data) {
          setTimeout(function(){location.reload();},1000);
        }
      });
    }
  });

  $("#SingleOptionSelector-0").change(function(){
    $(".sticky_option").val( this.value );
  });
  $(".sticky_option").change(function(){
    $("#SingleOptionSelector-0.single-option-selector-product-template").val( this.value ).trigger("change");
  });

  $( window ).load(function() {
    setTimeout(function(){
      $(".jdgm-rev-widg__reviews .jdgm-rev").each(function(k, v){
        var jdgm__author =  $(this).find('.jdgm-rev__author').html();
        var jdgm__timestamp =  $(this).find('.jdgm-rev__timestamp').html();
        $( this ).find('.jdgm-rev__body').after( '<div class="jdgm__author_timestamp"><div class="jdgm__author">'+ jdgm__author + '.</div><div class="jdgm__timestamp">LE ' + jdgm__timestamp + '</div></div>' );
      });
    }, 1000);
  });

  $(document).on("click", ".btn-book" ,function(e){
    $(this).parent().parent().find('.add-to-cart-icon').click();
  });

});

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setRadio(){
  if($(".bold-bundles-child-product__variant-selector").length){
    $(".bold-bundles-child-product__variant-selector").each(function(k, v){
      $(this).attr("data-i",k);
      $(this).attr("data-select","boldselect"+k);
      var ds = "boldselect"+k;
      $(this).after('<div id="v'+k+'" class="variant_bold"></div>');
      var select = $(this);
      var option = $(this).find("option");
      $(option).each(function(i, e) {
        ($("<input type='radio' name='v"+k+"' />")
         .attr("value", $(this).val())
         .attr("checked", i == 0)
         .on("click", function() {
          $("[data-select='"+ds+"']").val($(this).val());
        }).add($("<label>"+ this.textContent +"</label>")))
        .appendTo("#v"+k);
      });
    })
  }

  if($(".bold-bundles-child-product-info__products").length){
    var element = $(".bold-bundles-child-product-info__products").clone();
    element.find(".variant_bold").remove();
    $(".product__sticky-element-selects").append(element);
  }
  $(".bold-bundles-child-product__variant-selector").on("change",function(){
    var id = $(this).attr("id");
    var ds = $(this).attr("data-select");
    var i = $(this).attr("data-i");
    var v = $(this).val();
    $("#v"+i).find("input").prop("checked", false);
    $("#v"+i).find("input[value='"+v+"']").prop("checked", true);
    $("[data-select='"+ds+"']").val(v);
  })

}
$( window ).on( "load", function() {
  $(document).on("click", ".add-to-cart-icon" ,function(e){
    $(this).parent().addClass("active-size-chart");
    $(this).parent().siblings().removeClass("active-size-chart");
    $('body').addClass("active-overlay");
    $('.size-chart-wrap').addClass("size_chart_wrap");
  });

  $(document).on("click", ".size-chart-wrap .size-chart-sec li" ,function(e){
    $(".add-to-cart-icon").parent().removeClass("active-size-chart");
    $('body').removeClass("active-overlay");
    $('.size-chart-wrap').removeClass("size_chart_wrap");
  });


  $(document).on("click", ".quick-add" ,function(e){
    $(this).parent().addClass("active-size-chart");
    $(this).parent().siblings().removeClass("active-size-chart");
    $('body').addClass("active-overlay");
    $('.size-chart-wrap').addClass("size_chart_wrap");
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { quantity: 1, id: $( this ).data('vid') },
      dataType: 'json',
      success: function() {
        $('.cart_succ_mesg').show();
        location.href = "/cart";
        setTimeout(function(){ $('.cart_succ_mesg').hide();  }, 1500);
      },
      error: function() {
        $('.cart_error_mesg').show();
        setTimeout(function(){ $('.cart_error_mesg').hide();  }, 2500);
      }
    });
  });

  $(document).on("click", ".site-footer__item-inner--link_list .h4" ,function(e){
    if($(window).width() <= 767){
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".site-footer__linklist").slideUp(500);
      }
      else {
        $(".site-footer__item-inner--link_list .h4").removeClass("active");
        $(this).addClass("active");
        $(".site-footer__linklist").slideUp(500);
        $(this).siblings(".site-footer__linklist").slideDown(500);
      }
    }

  });
  setRadio();
});

$(document).mouseup(function(e) {
  var container = $(".size_chart_wrap");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    if($('body').hasClass("active-overlay")){
      $(".add-to-cart-icon").parent().removeClass("active-size-chart");
      $('body').removeClass("active-overlay");
      $('.size-chart-wrap').removeClass("size_chart_wrap");
    }
  }
});

// Mobile Menu Close on outside click
$(document).click(function(){
  $(document).on("click", "body" ,function(e){
    if($(window).width() < 1024){
      var target = $(e.target);
      if(e.target.nodeName == 'BODY'){
        if($("body").hasClass("nav_overlay_open")){
          theme.MobileNav.toggleMobileNav();
        }
      }
    }
  })
});


var current_url = window.location.href;
var str2 = "products";
if(current_url.indexOf(str2) != -1){
  $(function() {
    var menu = $('.product-form-product-template');
    var productform = $('.product-form-product-template').outerHeight();
    $(".product-form-main-wrap").css('min-height', productform);
    var hieghtThreshold = $("#MainContent").offset().top;
    var hieghtThreshold_end  = $("#MainContent").offset().top +$("#MainContent").height();
    $(window).scroll(function() {
      var scroll = $(window).scrollTop()-$(".product-single__photos").height()-$(".product-tvp-wrap").height()-$(".product-form-product-template").height();
      if (scroll >= hieghtThreshold && scroll <=  hieghtThreshold_end ) {
        menu.addClass('sticky_add_to_cart');
      } else {
        menu.removeClass('sticky_add_to_cart');
      }
    });
    $(window).scroll(function() {
      var scroll = $(window).scrollTop()-$(".product-tvp-wrap").height()-$(".product-form-product-template").height();
      if (scroll >= hieghtThreshold && scroll <=  hieghtThreshold_end ) {
        menu.addClass('desk_sticky_add_to_cart');
      } else {
        menu.removeClass('desk_sticky_add_to_cart');
      }
    });
  })
}

$(window).resize(function(){
  var productform = $('.product-form-product-template').outerHeight();
  $(".product-form-main-wrap").css('min-height', productform);
});

$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
  var finalQTY = $('#updates_plus_minus').val();
  var finalVID = $('.c_product_vid').val();
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity='+finalQTY+'&id='+finalVID,
    dataType: 'json',
    success: function(cart) {
      $(".cart-popup__cta-link").find("span[data-cart-popup-cart-quantity]").text(cart.item_count).attr('aria-label', cart.item_count);
      $("#CartCount").find("span[data-cart-count]").text(cart.item_count);
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  $.ajax(params);
});

// Cookies Script
function cookiesPolicyBar(){
  // Check cookie
  setTimeout(function(){
    if (getCookie('misterk_cookies') != "active") $('#cookieAcceptBar').show();
    if (getCookie('misterk_cookies') != "active") $('body').addClass("body-cookies");
  },500)
  //Assign cookie on click
  $('.cookies-bar__cta').on('click',function(){
    setCookie('misterk_cookies', 'active', 1); // cookie will expire in one day
    $('#cookieAcceptBar').fadeOut();
    $('body').removeClass("body-cookies");
  });

  $("#close_cookies").on('click',function(){
    $('#cookieAcceptBar').fadeOut();
    $('body').removeClass("body-cookies");
  });
}

$(document).ready(function(){
  var h = $('.announcement-bar').outerHeight();
  var h1 = $('.site-header').outerHeight();
  var h2 = h + h1;
  var s = $('.search-bar').outerHeight();
  $("#shopify-section-header").css('min-height', h2);
  $(".search-bar").css('top', s);
  $(window).scroll(function() {
    if ($(this).scrollTop() > h){
      $('.site-header').addClass("sticky");
      $('#SearchDrawer').addClass("sticky");
    }
    else{
      $('.site-header').removeClass("sticky");
      $('#SearchDrawer').removeClass("sticky");
    }
  });
});


$(window).resize(function(){
  var h = $('.announcement-bar').outerHeight();
  var h1 = $('.site-header').outerHeight();
  var h2 = h + h1;
  var s = $('.search-bar').outerHeight();
  $("#shopify-section-header").css('min-height', h2);
  $(".search-bar").css('top', s);
  $(window).scroll(function() {
    if ($(this).scrollTop() > h){
      $('.site-header').addClass("sticky");
      $('#SearchDrawer').addClass("sticky");
    }
    else{
      $('.site-header').removeClass("sticky");
      $('#SearchDrawer').removeClass("sticky");
    }
  });

  setInterval(function(){
    PageInits.collection('.tab-icon-wrap');
  }, 2000);
});


/* Equal Height JS */
PageInits = {
  collection: function(a){
    var top = 0;
    var main = $(a);
    var randomClass = ( 'eH' + Math.random() ).replace('.','');
    main.each( function() {
      var distanceFromTop = $(this).offset().top;
      if ( distanceFromTop > top ) {
        $('.' + randomClass).removeClass(randomClass);
        top = distanceFromTop;
      }
      $(this).addClass(randomClass);
      $(this).css('min-height','auto');
      var newHeight = (Math.max.apply(null, $('.' + randomClass).map( function() {
        return $(this).outerHeight();
      }).get()));
      $('.' + randomClass).css('min-height',newHeight);
    }).removeClass(randomClass);
  }
}
$(function (){
  'use strict';
  setInterval(function(){
    PageInits.collection('.tab-icon-wrap');
  }, 3000);
});

//=== CMS Page Equl Height ===================================================
PageInits = {
  collection: function(a){
    var top = 0;
    var main = $(a);
    var randomClass = ( 'eH' + Math.random() ).replace('.','');
    main.each( function() {
      var distanceFromTop = $(this).offset().top;
      if ( distanceFromTop > top ) {
        $('.' + randomClass).removeClass(randomClass);
        top = distanceFromTop;
      }
      $(this).addClass(randomClass);
      $(this).css('height','auto');
      var newHeight = (Math.max.apply(null, $('.' + randomClass).map( function() {
        return $(this).outerHeight();
      }).get()));
      $('.' + randomClass).css('height',newHeight);
    }).removeClass(randomClass);
  }
}

$( document ).ready(function() {
  'use strict';
  setTimeout(function(){ PageInits.collection('.cms-product-main-wrap .cms-product'); }, 1000);
  setTimeout(function(){ PageInits.collection('.cms-product-main-wrap .cms-product img'); }, 600);
});

$(window).resize(function(){
  setTimeout(function(){ PageInits.collection('.cms-product-main-wrap .cms-product'); }, 1000);
  setTimeout(function(){ PageInits.collection('.cms-product-main-wrap .cms-product img'); }, 600);
});

$(document).on("click", ".ajax_cart_textnote" ,function(){
  $('.cartnoteshow').toggle();
  $(".cartnoteshow").parent().parent().parent().parent().toggleClass("cart-ajax-drawer-main");
});

$(document).ready(function(){
  var url = window.location.href;
  if(url.includes("/collections/"))
  {
    var split = url.split("/collections/");
    var select = split[1];
    var split_select = select.split("/");
    var split_val = split_select[1];
    $("#all-tags option").each(function(){
      var attr_val = $(this).data('tags');
      if(attr_val==split_val){
        $(this).attr("selected","selected");
      }else{
        $(this).removeAttr("selected","selected");
      }

    });
  }
  $('#all-tags').on('change', function() {
    var tag_url = $(this).val();
    window.location.href=tag_url;

  });
});

